<template>
  <div class="cx-div--outer">
    <div class="cx-div m-mapitem__resultlist">
      <article v-for="poi in selectedResults" :key="poi.id"
        tabindex="0"
        :aria-label="poi.name"
        role="button"
        :id="poi.id"
        @click.prevent="$emit('poiSelected', poi)"
        class="m-resultlist__content cx-t10 -border-bottom">
        {{ poi.name }}
      </article>
    </div>
    <nav class="cx-row--line" v-if="totalPage > 1">
      <a :href="!hasPrevPage ? null : '#'" role="button" :aria-label="$t('common.previousPage')" class="cx-link m-mapitem__nav-previous" :class="{ '-disable': !hasPrevPage }" @click.prevent="prevPage">
        <i class="far fa-chevron-left"></i> {{ $t('common.previousPage') }}
      </a>
      <span>{{ page }} / {{ totalPage }}</span>
      <a :href="!hasNextPage ? null : '#'" role="button" :aria-label="$t('common.nextPage')" class="cx-link m-mapitem__nav-next" :class="{ '-disable': !hasNextPage }" @click.prevent="nextPage">
        {{ $t('common.nextPage') }} <i class="fa fa-chevron-right"></i>
      </a>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'accessibility-result',
  props: ['results'],
  data() {
    return {
      page: 1,
      pageSize: 15,
    };
  },
  watch: {
    results() {
      this.page = 1;
    },
  },
  computed: {
    selectedResults() {
      const start = (this.page - 1) * this.pageSize;
      return this.results.slice(start, start + this.pageSize);
    },
    totalPage() {
      return Math.ceil(this.results.length / this.pageSize);
    },
    hasPrevPage() {
      return this.page > 1;
    },
    hasNextPage() {
      return this.page < this.totalPage;
    },
  },
  methods: {
    getAddress(poi) {
      switch (this.$i18n.locale) {
        case 'zh-hant':
          return poi['infos'] && poi['infos']['基本資料'] && poi['infos']['基本資料']['地址'] ? poi['infos']['基本資料']['地址'][0] : '';
          break;

        case 'en':
          return poi['infos'] && poi['infos']['Information'] && poi['infos']['Information']['Address'] ? poi['infos']['Information']['Address'][0] : '';
          break;

        case 'pt':
          return poi['infos'] && poi['infos']['Informações básicas'] && poi['infos']['Informações básicas']['Endereço'] ? poi['infos']['Informações básicas']['Endereço'][0] : '';
          break;
      
        default:
          break;
      }
    },
    prevPage() {
      if (this.hasPrevPage) {
        this.page -= 1;
        this.$emit('paging');
      }
    },
    nextPage() {
      if (this.hasNextPage) {
        this.page += 1;
        this.$emit('paging');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-height: 756px) {
  .cx-div--outer {
    position: sticky;
    top: 0;
  }
  .m-resultlist{
    &__content{
      padding-left: .5rem;
      padding-right: .5rem;
    }
  }
}
</style>
